import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Media } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesMedia, validationSchemaMedia } from "./MediaCommon"
import MediaForm from "./MediaForm"
import { useCreateMedia } from "../../hooks/media"

export default function MediaCreate() {
  const createMedia = useCreateMedia()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesMedia(), [])
  const validationSchema = useMemo(() => validationSchemaMedia(), [])

  useBreadcrumbs([{ label: "Immagini", href: "/media/media" }, { label: "Creazione Immagine" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova immagine</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createMedia.mutateAsync(values as Media).then((media) => {
                navigate(`/media/media/${media.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <MediaForm />
                </Container>
                <BottomFormFixed url="/media/media" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
